import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import BlockContent from "../../block-content";

const Result = ({ result, handleResultIndicator }) => {
  const data = useStaticQuery(graphql`
    query resultsQuery {
      results: sanityResults {
        title
        _rawResultItems
      }
    }
  `);

  const resultsData = (data || {}).results;

  const outcomes = () => {
    if (result >= 5) {
      let blockData = resultsData._rawResultItems.find(
        resultItem => resultItem.resultType[0] === "RESULTYPE_0"
      );

      handleResultIndicator('result--red')

      return (
        <div>
          <BlockContent blocks={blockData.message || []} />
        </div>
      );
    } else if (result === 3 || result === 4) {
      let blockData = resultsData._rawResultItems.find(
        resultItem => resultItem.resultType[0] === "RESULTYPE_1"
      );
      handleResultIndicator('result--amber')
      return (
        <>
          <BlockContent blocks={blockData.message || []} />
        </>
      );
    } else if (result === 1 || result === 2) {
      let blockData = resultsData._rawResultItems.find(
        resultItem => resultItem.resultType[0] === "RESULTYPE_2"
      );
      handleResultIndicator('result--yellow')
      return (

        <div className="result--green-disabled">
          <BlockContent blocks={blockData.message || []} />
        </div>
      );
    } else if (result === 0) {
      let blockData = resultsData._rawResultItems.find(
        resultItem => resultItem.resultType[0] === "RESULTYPE_3"
      );
      handleResultIndicator('result--green')
      return (
        <>
          <BlockContent blocks={blockData.message || []} />
        </>
      );
    }
  };

  return (
    <>
      <div className="formStep--wrapper--result">
        <h2>Ergebnis</h2>
        <div className="result--wrapper">{outcomes()}</div>
      </div>
    </>
  );
};

export default Result;
